import React, { useState, useEffect } from 'react';
import { useAuth } from '../../components/content/auth.jsx';
import CardContainer from '../../components/card/card-container.jsx';
import LabelNumber from '../../components/label/label-number.jsx';
import Api from '../../api/global.service';
// import { deleteByUUID } from './cooperativas-crud.js';
import env from '../../environment.js';
import { Link } from 'react-router-dom';
import NoPagination from '../../components/pagination/noPagination.jsx';
import SearchColumn from '../../components/search/search-column.jsx';
import ListToolbar, { BtnNuevo } from '../../nuup/componentes/Toolbar/ListToolbar.jsx';
import useSecretUnlock from '../../hooks/useSecretUnlock';

const CooperativasList = () => {
  const auth = useAuth();

  const table = 'cooperativas';
  const url = '/admin/cooperativas';

  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [blocking, setBlocking] = useState(false);
  const [configUnlocked, handleTitleClick] = useSecretUnlock();

  const columns = React.useMemo(
    () => [
      // {
      //   Header: 'ACCIONES',
      //   accessor: 'uuid',
      //   Cell: cell => (
      //     <div className="with-btn text-nowrap">
      //       {auth.hasPermission('COOPERATIVAS_EDITAR') && (
      //         // eslint-disable-next-line react/destructuring-assignment
      //         <Link to={{ pathname: `${url}/edit/${cell.row.original.uuid}` }} className="m-r-2">
      //           <button type="button" className="btn btn-sm btn-sirio m-r-2">
      //             <i className="fa fa-pen"></i> Editar
      //           </button>
      //         </Link>
      //       )}
      //       {auth.hasPermission('COOPERATIVAS_ELIMINAR') && (
      //         <button type="button" onClick={() => handleDelete(cell)} className="btn btn-sm btn-danger m-r-2">
      //           <i className="fa fa-trash"></i> Eliminar
      //         </button>
      //       )}
      //     </div>
      //   ),
      // },
      {
        Header: 'NOMBRE',
        accessor: 'nombre',
        sortable: true,
        Cell: ({ row, value }) => (
          <div style={{ width: '200px' }}>
            <img
              src={`${env.assetURL}/${row.original.logo}`}
              alt=""
              style={{ width: '30px', height: '30px', marginRight: '6px', borderRadius: '30px' }}
            />
            <span>{value}</span>
          </div>
        ),
      },
      {
        Header: 'DESCRIPCIÓN',
        accessor: 'descripcion',
        sortable: true,
      },
      ...(configUnlocked
        ? [
            {
              Header: 'CONFIGURACIÓN',
              accessor: 'id',
              Cell: ({ row }) => (
                <Link to={{ pathname: `/admin/cooperativas/config/${row.original.id}` }}>
                  <button type="button" className="btn btn-sm btn-sirio">
                    <i className="fa fa-cog"></i> Configurar
                  </button>
                </Link>
              ),
            },
          ]
        : []),
      {
        Header: 'LOGO',
        accessor: 'logo',
        sortable: true,
      },
      {
        Header: 'CUENTA KOBO',
        accessor: 'cuenta_kobo',
        sortable: true,
      },
      {
        Header: 'CERTIFICACIÓN',
        accessor: 'certificacion',
        sortable: true,
      },
      {
        Header: 'TOTAL DE CUENTAS',
        accessor: 'total_cuentas',
        sortable: true,
        Cell: ({ value }) => {
          return <LabelNumber value={value}></LabelNumber>;
        },
      },
      {
        Header: 'FECHA DE CREACIÓN',
        accessor: 'created_at',
        sortable: true,
      },
      {
        Header: 'FECHA DE ACTUALIZACIÓN',
        accessor: 'updated_at',
        sortable: true,
      },
      // {
      //   Header: 'DESCARGA ACOPIOS CICLO 2023-2024',
      //   accessor: 'recibo_pdf',
      //   sortable: true,
      //   Cell: ({ row }) => {
      //     // TODO: eliminate hardcoded id_ciclo as 2
      //     return (
      //       <LinkDownload
      //         isZip
      //         url={`recibos/cooperativa/acopios/3/${row.original.id}`}
      //         label="Descargar"
      //         icon={env.images.icon.pdf}></LinkDownload>
      //     );
      //   },
      // },
    ],
    [configUnlocked]
  );

  const searchColumns = React.useMemo(
    () => [
      { value: 0, target: '', label: 'TODO' },
      { value: 1, target: 'nombre', label: 'NOMBRE' },
      { value: 2, target: 'descripcion', label: 'DESCRIPCIÓN' },
      { value: 3, target: 'logo', label: 'LOGO' },
      { value: 4, target: 'cuenta_kobo', label: 'CUENTA KOBO' },
      { value: 5, target: 'certificacion', label: 'CERTIFICACIÓN' },
      { value: 6, target: 'total_cuentas', label: 'TOTAL DE CUENTAS' },
      { value: 7, target: 'created_at', label: 'FECHA DE CREACIÓN' },
      { value: 8, target: 'updated_at', label: 'FECHA DE ACTUALIZACIÓN' },
    ],
    []
  );

  // const handleDelete = event => {
  //   deleteByUUID(event.cell.row.original.uuid);
  // };

  useEffect(() => {
    setBlocking(true);
    Api.search(table, {
      sort: [{ column: 'nombre', sort: 'asc' }],
    })
      .then(response => {
        setData(response.data);
        setOriginalData(response.data);
        setBlocking(false);
      })
      .catch(e => {
        // eslint-disable-next-line no-console
        console.log('e', e);
        setBlocking(false);
      });
  }, []);

  const setDataFilter = data => {
    setData(data);
  };

  return (
    <div>
      {auth.hasAccess('COOPERATIVAS') && (
        <>
          <CardContainer height={'100%'}>
            <h2 className="font-lato-normal-400 page-title" onClick={handleTitleClick}>
              Cooperativas
            </h2>
            <ListToolbar left={<SearchColumn data={originalData} columns={searchColumns} setDataFilter={evt => setDataFilter(evt)} />}>
              <BtnNuevo show={auth.hasPermission('COOPERATIVAS_NUEVO')} to={{ pathname: `${url}/create` }}>
                Nuevo
              </BtnNuevo>
            </ListToolbar>

            {auth.hasPermission('COOPERATIVAS_VER') && <NoPagination blocking={blocking} columns={columns} data={data}></NoPagination>}
          </CardContainer>
        </>
      )}
    </div>
  );
};

export default CooperativasList;
